import { defineStore } from 'pinia'
import { ref } from 'vue'
import { api } from '@shared/api'
import { toast } from '@shared/lib'

export const useContactsStore = defineStore('contacts', () => {
  const content = ref('')
  const lastUpdated = ref(null)

  const getContacts = async () => {
    try {
      const response = await api.get('/api/v1/admin/contacts')
      content.value = response.data.content || ''
      lastUpdated.value = response.data.updated_at
      return response.data
    } catch (error) {
      console.error('getContacts', error)
      toast.error('Произошла ошибка при получении контактов')
    }
  }

  const updateContacts = async (newContent) => {
    try {
      const response = await api.put('/api/v1/admin/contacts', { content: newContent })
      await getContacts()
      toast.success('Успешно обновили контакты')
      return response.data
    } catch (error) {
      console.error('updateContacts', error)
      toast.error('Произошла ошибка при обновлении контактов')
    }
  }

  const clearContent = () => content.value = ''

  return {
    content, lastUpdated,
    getContacts, updateContacts, clearContent
  }
})